import { useSelector } from "react-redux";

import { selectMarksByDeploymentIdAndSpeciesId } from "selectors";
import { useResolveSpeciesId } from "hooks";

/** *
 * Conditional Renderer for checking if the deployment
 * that drafted the sale lot has deployment marks configured
 * for the species used.
 *
 * Pass `selectedSpeciesId` when there is no current sale to derive the species from
 * (e.g. during sale creation). Falls back to the current-sale-derived species
 * when `selectedSpeciesId` is omitted.
 */
export const HasDeploymentMarks = ({
  deploymentId,
  selectedSpeciesId = null,
  children,
}) => {
  const speciesId = useResolveSpeciesId(selectedSpeciesId);
  const markOptions = useSelector(
    selectMarksByDeploymentIdAndSpeciesId(deploymentId, speciesId),
  );

  if (markOptions.length === 0) {
    return null;
  }
  return children;
};
